import React from 'react';

export default class FacebookPixelEventLogger extends React.Component {

    constructor(props) {
        super(props);

        // See https://www.facebook.com/business/help/402791146561655
        // and https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking
        this.standardEvents = {
            AddToCart: true,
            AddPaymentInfo: true,
            AddToWishlist: true,
            CompleteRegistration: true,
            Contact: true,
            CustomizeProduct: true,
            Donate: true,
            FindLocation: true,
            InitiateCheckout: true,
            Lead: true,
            Purchase: true,
            Schedule: true,
            Search: true,
            StartTrial: true,
            SubmitApplication: true,
            Subscribe: true,
            ViewContent: true
        }
    }

    handleEvent(eventName, eventData, options) {

        if (!window.fbq || !options || !options.fbPixel) {
            return false;
        }

        if (this.standardEvents[eventName]) {
            window.fbq('track', eventName, eventData);
        }
        else {
            window.fbq('trackCustom', eventName, eventData);
        }

        return true;
    }

    // This component has no state!
    shouldComponentUpdate() {
        return false;
    }

    componentDidMount() {
        const analyticsConfig = this.props.tenantConfig.analytics;
        if (!(analyticsConfig && analyticsConfig.facebook &&  analyticsConfig.facebook.enabled)) {
            // Disabled. Do nothing.
            return;
        }

        if (window.eventDispatcher) {
            window.eventDispatcher.addEventHandler(this);

            let self = this;

            if (window.addEventListener) {
                window.addEventListener('load', function () {
                    self.enableFacebookPixelLogging();
                }, false);
            }
            else if (window.attachEvent) {
                window.attachEvent('onload', function () {
                    self.enableFacebookPixelLogging();
                });
            }
        }
    }

    componentWillUnmount() {
        window.eventDispatcher.removeEventHandler(this);
    }

    enableFacebookPixelLogging() {

        if (window.fbq) {
            return;
        }

        const analyticsConfig = this.props.tenantConfig.analytics;
        const fbPixel = analyticsConfig.facebook.fbPixel;

        const html = `!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${fbPixel}');
  fbq('track', 'PageView');`;

        setTimeout(function () {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = html;

            document.body.appendChild(script);
        }, 32);
    }

    render() {
        return null;
    }
}
